import { gql } from '@apollo/client';

export const GET_ALL_LEVELS = gql`
  query GetAllLevels {
    getAllLevels {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_LEVEL = gql`
  mutation CreateLevel($input: CreateLevelInput!) {
    createLevel(input: $input) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_LEVEL = gql`
  mutation UpdateLevel($updateLevelId: ID!, $input: UpdateLevelInput!) {
    updateLevel(id: $updateLevelId, input: $input) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_LEVEL = gql`
  mutation DeleteLevel($deleteLevelId: ID!) {
    deleteLevel(id: $deleteLevelId)
  }
`;
